import styled from "styled-components";
import {Card} from "../../../styles/components";

export const Container = styled.div`
  width: 100%;
  height: 100%;
  padding: 5vh 1vw;
  color: ${({theme}) => theme.colors.black};

  @media only screen and (${({theme}) => theme.media.extraLarge}) {
    padding: 5vh 12% 8vh;
  }
`

export const CardInfo = styled(Card)`
    padding: 100px;
`

export const Title = styled.div`
  font-size: 32px;
  height: 15%;
  margin-bottom: 3%;
  
  & svg path {
    fill: ${({theme}) => theme.colors.title};
  }
`

export const TextBlock = styled.div`
  width: 100%;
  height: 82%;
`


export const SubTitle = styled.div`
  font-size: 24px;
  line-height: 40px;
  margin-bottom: 1rem;
  color: ${({theme}) => theme.colors.text};
`

export const Text = styled.div`
  font-size: 24px;
  line-height: 40px;
  color: ${({theme}) => theme.colors.text};
`

export const Text2 = styled.div`
  display: flex;
  align-items: flex-end;
  font-size: 24px;
  line-height: 40px;
  font-style: italic;
  color: ${({theme}) => theme.colors.red};
  
  & img {
    width: auto;
    height: 250px;
    margin-left: 30px;
  }
`